import React, { useEffect, useState } from "react";
import {
  FormControlLabel,
  TextField,
  Button,
  Switch,
  CircularProgress,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useSnackbar } from "notistack";
import { set_general_review_date_api } from "src/DAL/programmeWorkout/programmeWorkout";
import { get_member_program_detail } from "src/DAL/Programme/Programme";

export default function ReviewsDate({ programme, isClosePop = () => {} }) {
  const { enqueueSnackbar } = useSnackbar();
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [filterData, setFilterData] = useState({
    general_review_date: null,
    apply_to_all_users: false,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (filterData.apply_to_all_users && !filterData.general_review_date) {
      enqueueSnackbar("Please select a review date before submitting.", {
        variant: "error",
      });
      return;
    }

    setIsFormLoading(true);
    let postData = {
      general_review_date: filterData.apply_to_all_users
        ? filterData.general_review_date
        : "",
      apply_to_all_users: filterData.apply_to_all_users,
    };

    const result = await set_general_review_date_api(
      postData,
      programme._id,
      "program"
    );
    if (result.code === 200) {
      isClosePop(false);
      setIsFormLoading(false);
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsFormLoading(false);
    }
  };

  const getProgrammeDetail = async () => {
    const result = await get_member_program_detail(null, programme?._id);
    if (result.code === 200) {
      if (result?.program?.review_settings?.general_review_date) {
        setFilterData((values) => ({
          ...values,
          ["apply_to_all_users"]:
            result?.program?.review_settings?.apply_to_all_users,
          ["general_review_date"]: result?.program?.review_settings
            ?.general_review_date
            ? new Date(result?.program?.review_settings?.general_review_date)
            : null,
        }));
      }
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleSelectOther = (name, value) => {
    setFilterData((values) => ({ ...values, [name]: value }));
  };

  useEffect(() => {
    getProgrammeDetail();
  }, [programme]);

  return (
    <>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center py-5">
          <CircularProgress color="primary" />
        </div>
      ) : (
        <>
          <p className="text-muted mt-2">
            <>
              Enable the Review feature to set a programme review date, which
              sorts the members in the Members tab based on how close their
              review date is to the current date. (Please note that this date
              will only apply to members who do not have a custom review date
              set in their profile.)
            </>
          </p>
          <div className="my-3">
            <FormControlLabel
              control={
                <Switch
                  checked={filterData.apply_to_all_users}
                  onChange={(e) =>
                    handleSelectOther("apply_to_all_users", e.target.checked)
                  }
                />
              }
              label="Review Date"
            />
          </div>

          {filterData.apply_to_all_users && (
            <div className="my-3">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Review Date *"
                  inputFormat="dd-MM-yyyy"
                  className="w-100"
                  value={filterData.general_review_date}
                  onChange={(newValue) => {
                    handleSelectOther("general_review_date", newValue);
                  }}
                  disablePast
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      className="inputs-fields"
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
          )}

          <div className="mb-3 text-end">
            <Button
              onClick={handleSubmit}
              disabled={isFormLoading || isLoading}
              variant="contained"
            >
              {isFormLoading ? "Loading..." : "Submit"}
            </Button>
          </div>
        </>
      )}
    </>
  );
}
